import { defineComponent as _defineComponent } from 'vue'
import type { SiffletButtonColor, SiffletButtonSize, SButtonProps } from '../SButton/SButton.vue';

type SiffletSplitButtonVariant = 'elevated' | 'outlined';

export interface SSplitButtonItem {
  text: string
  icon?: string
  onClick?: () => void
  to?: Location | string
}

export interface SSplitButtonProps extends SButtonProps {
  to?: string | object | null;
  text?: string;
  color?: SiffletButtonColor;
  variant?: SiffletSplitButtonVariant;
  disabled?: boolean;
  icon?: string;
  asyncAction?: (arg?: any) => Promise<any>;
  tooltip?: string | null;
  size?: SiffletButtonSize;
  dataTrackButton?: string;
  dataTrackMenuButton?: string;
  beta?: boolean;
  items: SSplitButtonItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SSplitButton',
  props: {
  asyncAction: { type: Function },
  to: null,
  disabled: { type: Boolean },
  text: null,
  tooltip: null,
  icon: null,
  size: null,
  variant: null,
  color: null,
  iconAlignment: null,
  dataTrack: null,
  beta: { type: Boolean },
  dataTrackButton: null,
  dataTrackMenuButton: null,
  items: null
},
  setup(__props) {




return { __sfc: true, }
}

})